import { CREATE_USER_FORM_REPORTS_ALL } from "./reportsAll.actionType";

export const REPORTS_ALL = 'reportsAll';

let initialState = {
    loading: false,
    reportsData: [
        {
            id: 1,
            name: 'Program Wise Report',
        },
        {
            id: 2,
            name: 'Style Wise Report',
        },
        {
            id: 3,
            name: 'Supplier Wise Report',
        },
    ],
    reportsAllUserForm: {
        id: '1'
    }

};

export let reportsAllReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {

        case CREATE_USER_FORM_REPORTS_ALL:
            return {
                ...state,
                loading: false,
                reportsAllUserForm: {
                    ...state.reportsAllUserForm,
                    [payload.key]: payload.value
                }
            }
        default:
            return state;
    }
}